import { getPageUrl } from '@/utils/helpers';
import { parseStringBool } from '@/utils/parse';
import { curry, get, getOr, lowerCase, pipe, replace } from 'lodash/fp';

export const resolveCategories = ({ raw, categoryType }: any): string[] => {
  if (!raw || !categoryType) {
    return [];
  }

  if (!Object.keys(raw).includes(categoryType)) {
    return [];
  }

  const category = raw[categoryType]?.raw || [];
  return Array.isArray(category) ? category : [category];
};

export const resolveESArray = (raw: any): string[] => {
  if (!raw) return [];

  return Array.isArray(raw) ? raw : [raw];
};

export const PARTNER_RESOURCES_CONTENT_TYPE = 'partner resources';

export const PARTNER_RESOURCES_ASSETS_TYPES = [
  'channel_program',
  'general_resource',
  'legal',
  'sales_tools',
];

export const DEFAULT_PARTNER_RESOURCES_ASSETS_TYPE = 'general_resource';

export const getPartnerResourceAssetName = (assetType: string) =>
  `partner_resources_image_${assetType}`;

export const getCardImageByCategory = (categories: string[]) =>
  pipe(get(0), lowerCase, replace(/\s+/g, '_'))(categories);

export const getDefaultAssetImage = (assetImageUrlMap: any) =>
  get(DEFAULT_PARTNER_RESOURCES_ASSETS_TYPE, assetImageUrlMap);

export const resolveCardImageByCategory = (cardCategories: string[], assetImageUrlMap: any) =>
  getOr(
    getDefaultAssetImage(assetImageUrlMap),
    getCardImageByCategory(cardCategories),
    assetImageUrlMap,
  );

export const isDownloadableAsset = (itemResult: any) => parseStringBool(itemResult?.download?.raw);

export const getThumbnailImage = (imageRaw: any, page: any) => getPageUrl({ url: imageRaw, page });

export const evaluateFallbackImage = (
  cardCategory: string[],
  assetImageUrlMap: any,
  page: any,
  itemResult: any,
) =>
  itemResult?.image?.raw
    ? getThumbnailImage(itemResult?.image?.raw, page)
    : resolveCardImageByCategory(cardCategory, assetImageUrlMap);

export const evaluateFallbackImageTo = curry(evaluateFallbackImage);
